var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useUniqueId } from '../../hooks/useUniqueId';
import { useSwitch } from './useSwitch';
/**
 * # Switch
 *
 * @description [vercel design switch](https://vercel.com/design/switch)
 *
 * 기본적인 스위치 컴포넌트입니다. 해당 컴포넌트로 모든 스위치를 나타냅니다.
 *
 * @param {SwitchProps} {@link SwitchProps} 기본적인 Switch 요소
 *
 * @example ```tsx
 * const [active, setActive] = useState('item1')
 * <Switch
 *   active={active}
 *   onChange={(value) => setActive(value)}
 *   items={[
 *     {
 *       name: 'Item1',
 *       value: 'item1',
 *       width: 100
 *     },
 *     {
 *       name: 'Item2',
 *       value: 'item2',
 *       width: 100
 *     }
 *   ]}
 * />
 * ```
 */
export var Switch = function (props) {
    var _a = useSwitch(props), items = _a.items, onChange = _a.onChange, otherProps = __rest(_a, ["items", "onChange"]);
    return (<Group {...otherProps}>
      {items === null || items === void 0 ? void 0 : items.map(function (item) {
            var uniqueId = useUniqueId();
            return (<Button key={"".concat(uniqueId)} {...otherProps} {...item} onClick={function () { return onChange(item.value); }}>
            {item.name}
          </Button>);
        })}
    </Group>);
};
var Group = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n\n  ", "\n"], ["\n  display: flex;\n\n  ", "\n"])), function (_a) {
    var size = _a.size, theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    height: ", "px;\n\n    & > button {\n      border-left: 0;\n    }\n\n    & > :first-of-type {\n      border-radius: 5px 0 0 5px;\n      border-left: 1px solid ", ";\n    }\n\n    & > :last-of-type {\n      border-radius: 0 5px 5px 0;\n    }\n  "], ["\n    font-size: ", ";\n    height: ", "px;\n\n    & > button {\n      border-left: 0;\n    }\n\n    & > :first-of-type {\n      border-radius: 5px 0 0 5px;\n      border-left: 1px solid ", ";\n    }\n\n    & > :last-of-type {\n      border-radius: 0 5px 5px 0;\n    }\n  "])), size === 'large' ? '1em' : '0.875em', size === 'small' ? 32 : size === 'middle' ? 40 : 48, theme.colors.PRIMARY.ACCENT_2);
});
var Button = styled.button(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: inherit;\n  padding: 1px 4px;\n  cursor: pointer;\n\n  ", ";\n"], ["\n  font-size: inherit;\n  padding: 1px 4px;\n  cursor: pointer;\n\n  ", ";\n"])), function (_a) {
    var width = _a.width, value = _a.value, active = _a.active, disabled = _a.disabled, theme = _a.theme;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n    border: 1px solid ", ";\n    min-width: ", "px;\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    color: ", ";\n    border: 1px solid ", ";\n    min-width: ", "px;\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), theme.colors.PRIMARY.FOREGROUND, theme.colors.PRIMARY.ACCENT_2, width, value !== active && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background: none;\n    "], ["\n      background: none;\n    "]))), value === active && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      font-weight: 700;\n      background-color: ", ";\n    "], ["\n      font-weight: 700;\n      background-color: ", ";\n    "])), theme.colors.PRIMARY.ACCENT_1), disabled && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      color: ", ";\n      cursor: not-allowed;\n    "], ["\n      color: ", ";\n      cursor: not-allowed;\n    "])), theme.colors.PRIMARY.ACCENT_3));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=Switch.jsx.map